module.exports = __webpack_public_path__ + "549c0b45dd437a99588d1dc9f532c328.svg";